import { styled } from 'styled-components';
import { blockStyle } from '../../../../../components/styles/Block';

export const RecordingOverviewBlock = styled.div`
  ${blockStyle}
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
